<template>
    <div class="home t-blue">
        <img class="logo" alt="Education Cloud Logo" src="~@/assets/logo.png">
        <img class="cloud" src="~@/assets/cloud_full.png">
        <img class="rocket" src="~@/assets/rocket.png">
        <div class="wrapper">
            <router-link to="/de/" class="language">
                <strong>Deutschland</strong><br>
                Konform mit dem DigitalPakt Schule
                <div class="language__flag" :style="{'background-image': 'url(' + require('@/assets/de.png') + ')'}"></div>
                <i class="fas fa-caret-right"></i>
            </router-link>
            <router-link to="/ch/" class="language">
                <strong>Schweiz (Deutsch)</strong><br>
                Konform mit dem Lehrplan 21
                <div class="language__flag" :style="{'background-image': 'url(' + require('@/assets/ch.png') + ')'}"></div>
                <i class="fas fa-caret-right"></i>
            </router-link>
            <div class="cookie-consent" v-if="display">
                <p>Wenn Sie weiter browsen oder «Akzeptieren» anklicken, stimmen Sie der Speicherung von Erstanbieter- und Drittanbieter-Cookies auf Ihrem Gerät zu, um die Seitennavigation zu verbessern, die Nutzung der Seite zu analysieren und unsere Marketingaktivitäten zu unterstützen. Mehr dazu in unserer <router-link to="/de/datenschutz">Cookie Richtlinie</router-link>.
                <div class="button" @click="display = false">Akzeptieren</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
      data(){
        return {
            display: true,
        }
      }
    }

</script>

<style scoped lang="scss">
    .cookie-consent {
        margin-top: 20px;
        background-color: rgba(255,255,255,0.8);
        color: black;
        padding: 10px;

        p {
          margin: 0;
          font-size: 18px;
          text-align: center;
        }

        .button {
          width: 60%;
          margin: 20px auto 0px auto;
          background-color: $orange;
          text-align: center;
          display: block;
        }

        a {
          color: black;
        }
    }

    .home {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .logo {
        position: absolute;
        top: 40px;
        left: 60px;
        width: 280px;
    }

    .rocket {
        position: absolute;
        top: 25vh;
        right: 5vw;
        width: 30vw;
        animation: fly 2s ease;
    }

    .cloud {
        position: absolute;
        bottom: -13vh;
        right: 0;
        width: 40vw;
    }

    .wrapper {
        max-width: 780px;
        padding: 0 40px;
    }

    .language {
        display: block;
        position: relative;
        padding: 15px 80px;
        width: 100%;
        border: 1px solid $white;
        margin-bottom: 25px;
        font-size: 30px;
        color: $white;
        text-decoration: none;
        font-weight: 400;
        transition: 0.2s all ease;

        strong {
            font-weight: 700;
        }

        i {
            position: absolute;
            right: 20px;
            top: 18px;
            font-size: 60px;
        }

        &__flag {
            width: 36px;
            height: 36px;
            border-radius: 100px;
            background-size: cover;
            background-position: center;
            position: absolute;
            top: 16px;
            left: 20px;
        }
    }

    .language:hover {
        background-color: $white;
        color: $blue;
    }

    @keyframes fly {
        0% {
            transform: translate(-20vw, 40vh)
        }
        100% {
            transform: translate(0,0)
        }
    }

    @media (max-width: 900px){
        .cloud {
            width: 70vw;
            bottom: -10vw;
        }
        .rocket {
            display: none;
        }
    }

    @media (max-width: 650px){
        .language {
            font-size: 20px;
            padding: 15px 60px;

            &__flag {
                width: 25px;
                height: 25px;
            }

            i {
                display: none;
            }
        }
        .logo {
            width: 200px;
        }
        .cookie-consent {
            p {
              font-size: 14px;
            }

            .button {
              font-size: 16px;
              padding: 5px;
            }
        }
        .wrapper {
          margin-top: 130px;
        }
        .home {
          overflow: scroll;
        }
    }
</style>
